import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkbox",
  "use": "checkbox-usage",
  "viewBox": "0 0 12 10",
  "content": "<symbol viewBox=\"0 0 12 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"checkbox\">\n<path d=\"M0.999771 4.71751L4.18175 7.89949L10.8993 1.18198\" stroke=\"white\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol